import { __decorate } from "tslib";
import { html, literal } from 'lit/static-html.js';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized, msg } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { tagStyles } from './tag.styles.js';
import '../icon/index.js';
import { ifDefined } from 'lit-html/directives/if-defined.js';
import { nothing } from 'lit';
import { live } from 'lit/directives/live.js';
let HlxTag = class HlxTag extends HelixElement {
    constructor() {
        super(...arguments);
        this.type = 'text';
        this.href = null;
        this.size = 'small';
        this.target = '_self';
        this.emphasis = 'bold';
        this.variant = 'brand';
        this.text = '';
        this.closable = false;
        this.selected = false;
        this.disabled = false;
        this.inputId = crypto.randomUUID();
        this.typeToTag = {
            text: literal `div`,
            button: literal `button`,
            link: literal `a`,
            toggle: literal `label`,
        };
    }
    render() {
        const tag = this.typeToTag[this.type];
        return html `
            ${this.type === 'toggle' ?
            html `
                        <input
                            id=${this.inputId}
                            type="checkbox"
                            role="switch"
                            part="input"
                            class="hlx-toggle"
                            .checked=${live(this.selected)}
                            ?disabled=${this.disabled}
                            @change=${this.handleSelect} />
                    `
            : nothing}
            <${tag}
                aria-disabled=${this.disabled ? 'true' : 'false'}
                part="base"
                data-testid="tag-base"
                for=${ifDefined(this.type === 'toggle' ? this.inputId : undefined)}
                href=${ifDefined(this.type === 'link' && !this.disabled ? this.href : undefined)}
                target=${ifDefined(this.type === 'link' ? this.target : undefined)}
                ?disabled=${this.disabled}
                class="${classMap({
            'hlx-tag': true,
            'hlx-animation-with-prefers-reduced-motion': true,
            'hlx-tag-sm': this.size === 'small',
            'hlx-tag-md': this.size === 'medium',
            [`hlx-tag-type-${this.type}`]: true,
            [`hlx-tag-${this.emphasis}`]: true,
            [`hlx-tag-${this.variant}`]: true,
            'hlx-tag-selected': this.selected,
            'hlx-tag-disabled': this.disabled,
            'hlx-tag-with-close-icon': this.closable,
        })}">
                <slot name="prefix" part="prefix" class="hlx-prefix-icon"></slot>
                <slot class="hlx-tag-text" part="tag-text">${this.text}</slot>
                ${this.closable ?
            html `
                            <hlx-icon
                                class="hlx-close-icon"
                                part="close-icon"
                                data-testid="close-icon"
                                title="${msg('Close icon')}"
                                name="xmark"
                                size="12"
                                @click=${this.handleDelete}></hlx-icon>
                        `
            : html `
                            <slot name="suffix" part="suffix" class="hlx-suffix-icon"></slot>
                        `}
            </${tag}>
        `;
    }
    handleDelete(event) {
        if (!this.disabled) {
            event.stopPropagation();
            event.preventDefault();
            this.emit('hlx-delete');
        }
    }
    handleSelect(event) {
        if (!this.disabled && this.type === 'toggle' && this.emphasis !== 'bold') {
            this.selected = !this.selected;
            this.emit('hlx-select');
        }
    }
};
HlxTag.styles = [componentStyles, tagStyles];
__decorate([
    property({ type: String, reflect: true })
], HlxTag.prototype, "type", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxTag.prototype, "href", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxTag.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxTag.prototype, "target", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxTag.prototype, "emphasis", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxTag.prototype, "variant", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxTag.prototype, "text", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HlxTag.prototype, "closable", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HlxTag.prototype, "selected", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HlxTag.prototype, "disabled", void 0);
HlxTag = __decorate([
    customElement('hlx-tag'),
    localized()
], HlxTag);
export { HlxTag };
//# sourceMappingURL=tag.js.map